module.exports = __webpack_public_path__ + "static/media/download.a7ffe8f5.svg";